module.exports = __webpack_public_path__ + "static/media/alan_walker.1580426f.png";